import { NavLink, useLocation } from "react-router-dom";
import { subscribeBadges } from "../../lib/sharedData";
import { useEffect, useState } from "react";
import { Sun, CalendarCheck, FolderOpen, Target, Mailbox } from "lucide-react";
import { useT } from "../../lib/i18n";


const TABS = [
  { to: "/today", label: "Vandaag", icon: Sun, testid: "tab-today", badge: "assistant" },
  { to: "/agenda", label: "Agenda", icon: CalendarCheck, testid: "tab-agenda", badge: "agenda" },
  { to: "/clients", label: "Dossiers", icon: FolderOpen, testid: "tab-dossiers" },
  { to: "/programs", label: "Programma's", icon: Target, testid: "tab-programs" },
  { to: "/inbox", label: "Berichten", icon: Mailbox, testid: "tab-messages", badge: "inbox" },
];

export default function MobileTabBar() {
  const t = useT();
  const loc = useLocation();
  const [badges, setBadges] = useState({});
  useEffect(() => subscribeBadges((b) => setBadges(b || {})), []);

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200"
      style={{ paddingBottom: "var(--sab)", height: "calc(var(--pm-nav-h) + var(--sab))" }}
      data-testid="mobile-tab-bar"
    >
      <div className="flex items-stretch px-1" style={{ height: "var(--pm-nav-h)" }}>
        {TABS.map((tab) => {
          const active = loc.pathname === tab.to || loc.pathname.startsWith(tab.to + "/");
          const count = tab.badge ? badges[tab.badge]?.count : 0;
          const Icon = tab.icon;
          return (
            <NavLink key={tab.to} to={tab.to} data-testid={tab.testid}
              className={`flex-1 flex flex-col items-center justify-center gap-1 relative active:scale-95 transition-transform ${active ? "text-slate-900" : "text-slate-400"}`}>
              <span className="relative">
                <Icon size={22} strokeWidth={active ? 2.25 : 1.75} />
                {count > 0 && (
                  <span className="absolute -top-1.5 -right-2.5 min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center" data-testid={`${tab.testid}-badge`}>
                    {count > 99 ? "99+" : count}
                  </span>
                )}
              </span>
              <span className={`text-[10px] leading-none ${active ? "font-semibold" : "font-normal"}`}>{t(tab.label)}</span>
              {active && <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full" style={{ background: "var(--pm-green)" }} />}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
